import { ValueList } from "appworks/utils/value-list";
import { slotModel } from "slotworks/model/slot-model";
import { AgsAbstractAutoplaySliderControl } from "./ags-abstract-autoplay-slider-control";

export class AgsTotalLossLimitSliderControl extends AgsAbstractAutoplaySliderControl {
    protected getModelData(): ValueList<number> {
        return slotModel.read().autoplay.lossLimit;
    }

    protected saveModelData(selectedValue: number) {
        const { autoplay } = slotModel.read();
        autoplay.lossLimit.currentValue = selectedValue;
        autoplay.lossLimit.lastSelectedValue = selectedValue ?? 0;
        slotModel.write({ autoplay });
    }
}
